import { Component, OnInit } from '@angular/core';
import { LayoutService } from '../../Services/layout.service';
import { TitleService } from 'src/app/shared/Services/title.service';
import { ErrormessageService } from '../../Services/errormessage.service';

@Component({
  selector: 'app-invalid-link',
  templateUrl: './invalid-link.component.html',
  styleUrls: ['./invalid-link.component.css']
})
export class InvalidLinkComponent implements OnInit {
  errorMessage: string = '';
  constructor(
    private _titleService: TitleService,
    private layoutService: LayoutService,
    private errorMessageService: ErrormessageService
  ) {
    var newTitle = 'Invalid Link';
    this._titleService.setTitle(newTitle);
    this.layoutService.setShowHeader(false);
    this.layoutService.setShowFooter(false);
    this.layoutService.setShowSidebar(false);
  }

  ngOnInit(): void {
    this.errorMessageService.errorMessage$.subscribe(message => {
      this.errorMessage = message;
    });
    if (this.errorMessage == "") {
        this.errorMessage = "Something Went Wrong.";
    }
  }
}
